<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title> IMPRESSÃO DE FATURA REEMBOLSO </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <alert
        :type="typeAlert"
        :visible="showAlert"
        :message="messageAlert"
        :clickClose="() => (showAlert = false)"
      ></alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="months"
                v-model="month"
                label="Mês"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="years"
                v-model="year"
                label="Ano"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="3">
              <v-select
                :items="companies_options"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="company_selected"
                multiple
                small-chips
                label="Franqueado"
                hide-details
                clearable
                dense
                outlined
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="company_selected.length === 1 && index === 0">
                    <span>{{ item.name }}</span>
                  </span>
                  <span v-if="index === 1 && company_selected.length > 0">
                    {{ company_selected.length }} Franqueados Selecionados
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" xs="6" md="3">
              <v-btn
                dark
                color="blue darken-3"
                small
                class="mt-1"
                @click="search"
              >
                Executar Consulta
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-simple-table dense fixed-header height="500">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th
                                class="text-left fs-12 text-no-wrap"
                                width="60px"
                              ></th>
                              <th class="text-left fs-12 text-no-wrap">
                                Filial
                              </th>
                              <th class="text-left fs-12" width="250px">
                                Franqueado
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Documento
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Faturamento
                              </th>
                              <th
                                class="text-right fs-12 text-no-wrap"
                                width="120px"
                              >
                                Vr. Documento
                              </th>
                              <th
                                class="text-right fs-12 text-no-wrap"
                                width="120px"
                              >
                                Parcelas
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="company in companies" :key="company.id">
                              <td>
                                <v-icon @click="print('analitico', company)"
                                  >mdi-printer</v-icon
                                >
                              </td>
                              <td>
                                {{ company.code }}
                              </td>
                              <td>
                                {{ company.name }}
                              </td>
                              <td>{{ company.code }}-{{ company.document }}</td>
                              <td>
                                {{ company.created_at }}
                              </td>
                              <td class="text-right">
                                {{ company.value }}
                              </td>
                              <td class="text-right">
                                {{ company.parcels }}
                              </td>
                            </tr>
                          </tbody>
                          <tfoot v-if="companies.length > 0">
                            <tr>
                              <th colspan="13">
                                Total de Faturas:
                                {{ companies.length }}
                              </th>
                            </tr>
                          </tfoot>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="400"
      v-model="linkDownload"
    >
      <v-card>
        <v-card-text class="pa-10">
          <v-btn
            class="ma-5 white--text justify-center d-flex"
            large
            color="indigo"
            target="_blank"
            :href="download.link"
            @click="() => (linkDownload = false)"
          >
            <v-icon left>mdi-cloud-download</v-icon>
            CLIQUE AQUI PARA BAIXAR
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="linkDownload = false">
            FECHAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { URL } from "@/api/config";

import * as CompanyAPI from "@/api/requests/CompanyRequest";

import Alert from "@/components/Alert";

export default {
  components: { Alert },
  data: () => ({
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
    month: "",
    years: [],
    year: "",
    loading: false,
    successSave: false,
    lazy: false,
    valid: true,
    companies: [],
    showAlert: false,
    typeAlert: "",
    messageAlert: "",
    linkDownload: false,
    download: {
      name: "",
      link: "#",
    },
    companies_options: [],
    company_selected: [],
  }),
  computed: {},
  created() {
    let dateNow = new Date();
    this.month = dateNow.getMonth() + 1;
    this.year = dateNow.getFullYear();
    let yearNow = dateNow.getFullYear();

    // COLOCA 10 ANOS PARA TRAS
    for (let i = 10; i >= 0; i--) {
      this.years.push(yearNow - i);
    }
    this.years = this.years.reverse();
    this.initialize();
  },
  methods: {
    async initialize() {
      await this.getCompanies();
    },
    validate() {},
    async getCompanies() {
      this.loading = true;
      this.companies_options = [];
      try {
        let data = await CompanyAPI.getAll("?type=fra,mul");
        this.companies_options = data.sort((a, b) =>
          a.code > b.code ? 1 : -1
        );
      } catch (error) {
        this.companies_options = [];
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async print(type, company) {
      this.loading = true;
      this.download = {
        name: "",
        link: "#",
      };
      this.linkDownload = false;
      try {
        let data = {};
        data.refund = company;
        data.type = type;
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let response = await fetch(`${URL}refund/print`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        this.loading = false;
        let res = await response.json();
        console.log(res);
        this.download.name = res.nome;
        this.download.link = `${URL}refund/download/${res.nome}`;
        this.linkDownload = true;
      } catch (error) {
        this.showAlert = true;
        this.typeAlert = "error";
        this.messageAlert =
          "Não foi possível imprimir esse relatório, entre em contato com o suporte";
      }
    },
    async search() {
      this.checkall = false;
      this.showAlert = false;
      this.messageAlert = "";
      this.typeAlert = "success";
      this.loading = true;
      this.companies = [];
      let data = {};
      data.month = this.month;
      data.year = this.year;
      data.company = this.company_selected;
      try {
        let myHeaders = new Headers({
          "Content-Type": "application/json",
        });
        let response = await fetch(`${URL}refund/search`, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        });
        let res = await response.json();
        if (res.length == 0) {
          this.showAlert = true;
          this.typeAlert = "warning";
          this.messageAlert =
            "Nenhuma Fatura disponível para ser impressa no período selecionado";
        } else {
          this.companies = res.sort((a, b) => (a.code > b.code ? 1 : -1));
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 11.5px;
}
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 12px !important;
}
</style>
